<template lang="pug">
div
  PromoTabContainer
  PromoCardContainer
</template>

<script>
import PromoCardContainer from '@/components/PromoCardContainer';
import PromoTabContainer from '@/components/PromoTabContainer';

export default {
  name: 'PromoHome',
  components: {
    PromoCardContainer,
    PromoTabContainer,
  },
  mounted() {
    this.getPromoRecommendations();
  },
  methods: {
    async getPromoRecommendations() {
      await this.$store.dispatch('getPromoRecommendations');
    },
  },
};
</script>